
/**
 * Has utility functions required for services
 * */
class HelperService {
  paramsList = {};
  headers = {};

  /**
   * @description setting header param
   * @param key
   * @param value
   */
  setHeaders(key, value) {
    this.headers[key] = value;
  }

  cleanHeaders() {
    this.headers = {};
  }

  /**
   *  @description Get the headers params
   * @return {}
   */
  getHeaders() {
    return this.headers;
  }
}

export default new HelperService();
